module.exports = __webpack_public_path__ + "img/US.be383f79.webp";